// extracted by mini-css-extract-plugin
module.exports = {"vote":"vote-1OO-O69l","voted":"voted-1mr35Uot"};